import { TaxIdTypeEnum } from "gen/model/taxIdTypeEnum";
import * as yup from "yup";

const investorEntityMetadataSchema = yup.object().shape({
  is_foreign: yup.boolean().required(),
  is_tax_exempt: yup.boolean().required(),
  erisa_investor: yup.boolean().required(),
  affiliated_with_sponsor: yup.boolean().required(),
  is_bank_holding_company: yup.boolean().required(),
});

export const investorEntityCreateSchema = yup
  .object()
  .shape({
    legal_name: yup.string().max(256).required(),
    external_id: yup.string().max(256).required(),
    metadata: investorEntityMetadataSchema.required(),
  })
  .required();

export const investorEntityEditSchema = yup
  .object()
  .shape({
    legal_name: yup.string().max(256).required(),
    short_name: yup.string().min(0).max(256).optional(),
    metadata: investorEntityMetadataSchema.required(),
    tax_id_type: yup.string().optional().nullable(), // oneOf doesn't work on nullable fields
    tax_id: yup
      .string()
      .optional()
      .nullable()
      .when("tax_id_type", {
        is: TaxIdTypeEnum.ssn,
        then: (schema) => schema.matches(/^\d{3}-?\d{2}-?\d{4}$/),
      })
      .when("tax_id_type", {
        is: TaxIdTypeEnum.ein,
        then: (schema) => schema.matches(/^\d{2}-?\d{7}$/),
      }),
  })
  .required();

export interface investorCreateFormData {
  name: string;
  primary_contact_email?: string;
}
export const investorCreateSchema = yup.object().shape({
  name: yup.string().max(256).required(),
  primary_contact_email: yup.string().email().optional(),
});

export const investorEditSchema = investorCreateSchema;
